import { Component, Inject, OnInit, Optional } from '@angular/core';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../../../core/data.service';
import { Widget, WidgetType } from '../../../core/template-definition.model';
import { CMPS_SCORECARD_WIDGET } from '../../../scorecard.metadata';
import { Rank } from '../../../scorecard.model';
import { TranslationKeyMap } from '../../pulse-widget.i18n';

@Component({
    selector: 'cmps-scorecard-ranks-pulse-widget',
    templateUrl: './ranks-pulse-widget.component.html',
})
@TakeUntilDestroy()
export class ScRanksPulseWidgetComponent implements OnInit {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;
    /** @private */ _ranks: Rank[];

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Optional()
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */
        public _widget: Widget,
    ) {}

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<Rank[]>(WidgetType.RANKINGS_GRID)
            .pipe(
                tap((data) => {
                    this._ranks = data || [];
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
